import { Component, OnInit } from '@angular/core';
import { CommonConstants } from './../common/utilities/commonConstants';
import { ActivatedRoute } from '@angular/router';
import { CookieHandlerService } from '../common/services/cookieHandler.service';
import { RouteContextProvider } from '../common/services/routeContextProvider.service';
import { HomeService } from '../home/home.service';
import { BitlyService } from './bitly.service';
import { Formatter } from '../common/services/formatter';

@Component({
    selector : '',
    templateUrl : './bitlyComponent.template.html',
    styleUrls : ['./bitlyComponent.style.scss'],
    providers: [BitlyService]
})

export class BitlyComponent implements OnInit {
    public isFailure = true;
    public isSuccess = false;
    public logoImage = 'assets/img/failureEmandate.svg';
    public returnReqParm = '';
    public isbitlyResponse = false;
    public failedError = false;
    private consentAuthToken: string;
    constructor(
         private route: ActivatedRoute,
         private _routeContextProvider: RouteContextProvider,
         private _homeService: HomeService,
         private _cookieHandler: CookieHandlerService,
         private _formatter: Formatter,
         private _bitlyService: BitlyService) {
        

    }
    ngOnInit() {
        this.returnReqParm = this.route.snapshot.queryParams.MandateResponse;
        this.consentAuthToken = this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.consentToken);
        this.authenticateSystem();
    }
    private authenticateSystem(): void {
        const userClientId = this._homeService.GetClientIdForUser();
        this.setSecretKeyForClientId(userClientId);
    }

    private setSecretKeyForClientId(clientId: string): void {
        this._homeService.GetSecretKeyForBasedOnClientId(clientId).subscribe((responseData: ActivitiModel.MTResponse<any>) => {
            if (!responseData.errorBean) {
                this._cookieHandler
                    .SetCookie(CommonConstants.CookieKeys.ClientId, clientId);
                this._cookieHandler
                    .SetCookie(CommonConstants.CookieKeys.SecretKey,
                        responseData.payload.secretKey);
                this.setSystemAuthToken(responseData.payload.secretKey, clientId);
            }
        });
    }

    private setSystemAuthToken(secretKey: string, clientId: string): void {
        this._homeService.GetSystemAuthToken({
            secretKey,
            clientId
        }).subscribe((responseData: ActivitiModel.MTResponse<any>) => {
            if (!responseData.errorBean) {
                const tokenObj = responseData.payload.tokens[0];
                console.log('tokens::', tokenObj);
                this._cookieHandler.SetCookie(CommonConstants.CookieKeys.JWToken, tokenObj.token);
                this._cookieHandler.SetCookie(CommonConstants.CookieKeys.GuardKey, tokenObj.guardKey);
                this._cookieHandler.SetCookie(CommonConstants.CookieKeys.GuardToken, this._formatter
                    .ConvertGuradKeyToGuardToken(tokenObj.guardKey));
                    this.validateBitly();
            }
        });
    }

    private validateBitly(){
        const consentdata = {
            authToken: this.consentAuthToken
        };

        this._bitlyService.validateBitly(this.returnReqParm, consentdata).subscribe((response: ActivitiModel.MTResponse<any>) => {
            this.isbitlyResponse = true;
            if (!response.errorBean) {
                this.checkBitLyStatus(response.payload.emandatePaymentStatus);
            }
        },
        (error) => {
            if (error.errorCode === 'EMS-134') {
                console.log('hello ', error.errorCode);
                this.isbitlyResponse = true;
                this.failedError = true;
            }
        });
    }

/*** Checks the bitly response status. */
    public checkBitLyStatus(bitlyStatus) {
        if (bitlyStatus.toLowerCase() == 'failure') {
            this.logoImage = 'assets/img/failureEmandate.svg';
            this.isFailure = true;
            this.isSuccess = false;
          } else if (bitlyStatus.toLowerCase() == 'success') {
            this.logoImage = 'assets/img/successEmandate.svg';
            this.isSuccess = true;
            this.isFailure = false;
          } else {
            this.logoImage = 'assets/img/emandate.svg';
            this.isSuccess = false;
            this.isFailure = false;
          }
    }
/*** Redirect to the apps login page. */
    // public redirectToApp() {
    //     window.location.href = CommonConstants.APIUrls.redirectToApp;
    // }
}
